import * as colors from 'components/common/colorConstants';
import styled from 'styled-components/macro';
import * as animations from 'components/common/animations';

export const Container = styled.div`
  padding: 16px;
  background-color: ${colors.baseBackground};
  position: relative;
  margin: 24px;
  border: 1px solid ${colors.lightGray21};
  border-radius: 3px;
  overflow: hidden;

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 10px !important;
    line-height: 16px;
    font-family: 'Roboto', sans-serif;
    color: ${colors.darkGray1};
    margin: 0px;
    padding: 0px;
  }
`;

export const CustomerProduct = styled(Container)`
  padding: ${(props) => (props.seeMorePresent ? '16px 16px 50px' : '16px')};
  background-color: ${colors.baseBackground};
  position: relative;
  margin: 0px 24px 24px;
  border: 1px solid ${colors.lightGray21};
  border-radius: 3px;
  overflow: hidden;
  white-space: pre-line;

  h1 {
    font-style: normal;
    font-weight: 500;
    font-size: 16px !important;
    line-height: 22px;
    font-family: 'Roboto', sans-serif;
    color: ${colors.lightBlack};
  }

  h4 {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 11px;
    line-height: 18px;
    color: ${colors.darkGray1};

    span {
      color: ${colors.lightBlack};
    }
  }

  a {
    font-family: 'Roboto', sans-serif;
    font-size: 10px;
    line-height: 16px;
    text-decoration-line: underline;
    color: ${colors.purple1};
    text-align: right;
    padding-top: 20px !important;
    display: inline-block;

    &:hover {
      color: ${colors.purple1};
    }
  }

  ${animations.fadeInSlow}
`;

export const ExpandLink = styled.p`
  color: ${colors.darkGray1};
  font-size: 9px;
  padding-top: 20px !important;

  img {
    margin-left: 9px;
  }

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  position: absolute;
  bottom: 16px;
  left: 16px;
`;

export const CustomerProductImage = styled.div`
  background: ${(props) => (props.url ? `url(${props.url}) no-repeat center center` : colors.lightBlack)};
  width: 149px;
  height: 129px;
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0px 0px 0px 16px;
  float: right;
  border: 1px solid ${colors.lightGray21};
`;

export const SectionLabel = styled.div`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${colors.lightBlack};
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  img {
    margin-left: 8px;
    &:hover {
      cursor: pointer;
    }
  }

  ${animations.fadeInSlow}
`;

export const SectionSubLabel = styled.div`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  color: ${colors.lightBlack};
  padding: 0px 24px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  img {
    margin-left: 8px;
    &:hover {
      cursor: pointer;
    }
  }

  ${animations.fadeInSlow}
`;

export const DividerLine = styled.div`
  width: 100%;
  height: 7px;
  background-color: ${colors.baseBackground};
  ${animations.fadeInSlow}
`;

export const MacroContainer = styled(Container)`
  overflow-wrap: break-word;

  h4 {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 11px;
    margin-top: 0px;
    color: ${colors.lightBlack};
    display: flex;
    align-items: center;
    justify-content: flex-start;

    img {
      margin-right: 8px;
    }

    img:nth-child(2) {
      margin-left: 8px;
      &:hover {
        cursor: pointer;
      }
    }
  }

  p {
    padding-bottom: 20px;
  }

  ${animations.fadeInSlow}
`;

export const NotHelpfulWrapper = styled.div`
  margin: 0px 24px 24px;
  padding: 24px 0px;
  border-top: 1px solid ${colors.lightGray21};

  p {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    color: ${colors.lightBlack};
    margin: 0px 0px 15px;
  }

  img {
    margin-left: 8px;
    cursor: pointer;
  }

  ${animations.fadeInSlow}
`;

export const SelectProductWrapper = styled.div`
  padding: 0px 0px 24px;
  margin: 0px 24px 0px;
  display: flex;
  flex-direction: row;
  background-color: none;
  justify-content: flex-start;

  div:last-child {
    margin-right: 0px;
  }
`;

export const SelectProduct = styled.div`
  padding: 6px;
  background-color: ${colors.baseBackground};
  position: relative;
  border: 1px solid ${colors.lightGray21};
  width: 121px;
  height: 121px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.5s;
  margin-right: 10px;

  div {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  h3 {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Roboto', sans-serif;
    color: ${colors.orange2};
    margin: 6px 0px 0px;
    padding: 0px;
  }

  h4 {
    font-family: 'Roboto', sans-serif;
    font-size: 10px;
    color: ${colors.darkGray1};
    margin: 0px;
  }

  &:hover {
    box-shadow: 0 0 9px 0 ${colors.lightGray21};
    cursor: pointer;
  }

  ${animations.fadeInSlow}
`;

export const SelectProductImage = styled.div`
  background: ${(props) => (props.url ? `url(${props.url}) no-repeat center center` : colors.lightBlack)};
  width: 100%;
  height: 75px;
  background-size: cover;
  border: 1px solid ${colors.lightGray21};
`;
